/* Boost V2 — cart drawer (CRO-003 / CRO-004 / CRO-005) */
(function(){
  'use strict';
  var drawer = document.querySelector('[data-cart-drawer]');
  var overlay = document.querySelector('[data-cart-overlay]');
  if (!drawer || !overlay) return;
  var bundleValidationRun = 0;
  var atlasOfferRenderRun = 0;
  var atlasOfferConfigCache = {};
  var atlasOfferValidationCache = {};
  var atlasOfferTimer = null;
  var atlasOfferReturnFocus = null;
  var atlasOfferBrochureReturnFocus = null;
  var atlasOfferBrochureParent = null;
  var atlasOfferBrochureScrollTop = 0;
  var atlasOfferBrochureVideo = null;
  var atlasOfferBrochureVideoWasPlaying = false;
  var atlasCartReelCache = {};
  var atlasCartReelRequests = {};
  var atlasCartReelObserver = null;
  var atlasCartReelsEnabled = true;
  var atlasCartMediaSettingLoaded = false;
  var atlasCartMediaSettingRequest = null;
  var atlasCartMediaSettingStorageKey = 'atlas-product-offer-cart-reels-enabled';
  var atlasOfferEventEndpoint = 'https://zpefopnpabbgvldtvpka.supabase.co/functions/v1/storefront-public-data';

  var threshold = parseInt((drawer.dataset.threshold || '1999'), 10);
  var copy = {
    emptyText: drawer.dataset.cartEmptyText || 'Your cart is empty.',
    emptyCta: drawer.dataset.cartEmptyCta || 'Start shopping',
    removeLabel: drawer.dataset.cartRemoveLabel || 'Remove',
    freeEmpty: drawer.dataset.freeEmpty || 'FREE delivery on every order over PKR 1,999',
    freeQualified: drawer.dataset.freeQualified || '✓ You qualify for FREE delivery!',
    freeBelow: drawer.dataset.freeBelow || 'PKR [X] more for FREE delivery!'
  };
  ensureAtlasCartExperienceStyles();
  var storedAtlasCartMediaSetting = readStoredAtlasCartMediaSetting();
  if (storedAtlasCartMediaSetting !== null) {
    atlasCartReelsEnabled = storedAtlasCartMediaSetting;
  }
  loadAtlasCartMediaSetting(false);

  function ensureAtlasCartExperienceStyles(){
    if (document.getElementById('atlas-cart-experience-styles')) return;
    var style = document.createElement('style');
    style.id = 'atlas-cart-experience-styles';
    style.textContent =
      '.cart-item{position:relative;display:grid!important;grid-template-columns:132px minmax(0,1fr) minmax(116px,148px)!important;column-gap:16px!important;align-items:start}.cart-item-content{min-width:0}.cart-item-title{min-width:0;line-height:1.12}.cart-item-title a{display:block;overflow-wrap:anywhere;word-break:normal}.cart-item-variant{margin-top:6px}.cart-item-price{min-width:116px;max-width:148px;text-align:right}' +
      '.cart-item-image.atlas-cart-media{position:relative;width:132px!important;height:132px!important;min-width:132px;overflow:hidden;border:1px solid rgba(226,182,0,.34);border-radius:20px!important;background:#f8f5ea;box-shadow:0 10px 24px rgba(7,20,38,.10)}.cart-item-image.atlas-cart-media img,.cart-item-image.atlas-cart-media video{display:block;width:100%;height:100%;object-fit:cover}.cart-item-image.atlas-cart-media.is-atlas-cart-reel{background:#061326;border-color:rgba(255,207,0,.50)}.cart-item-image.atlas-cart-media.is-atlas-cart-reel:after{content:"";position:absolute;z-index:1;top:8px;right:8px;width:9px;height:9px;border:2px solid #fff;border-radius:999px;background:#ffcf00;box-shadow:0 0 0 3px rgba(3,10,20,.45);pointer-events:none}' +
      '.atlas-offer-line-price{display:flex;flex-direction:column;align-items:flex-end;gap:2px}.atlas-offer-line-price s{color:#7d8792;font-size:11px;font-weight:650}.atlas-offer-line-price strong{font-size:15px;line-height:1.15}.atlas-offer-applied{display:inline-flex;align-items:center;justify-content:center;max-width:100%;margin-top:5px;border-radius:999px;background:#dcfce7;color:#067647;padding:5px 8px;font-size:9px;font-weight:950;line-height:1.2;text-align:center;white-space:normal;overflow-wrap:anywhere}' +
      '.cart-offer-secured-banner{display:flex;align-items:center;gap:8px;margin:14px 0 0;border:1px solid rgba(255,207,0,.38);border-radius:13px;background:linear-gradient(90deg,rgba(255,207,0,.17),rgba(255,255,255,.07));color:#fff4b8;padding:10px 12px;font-size:11px;font-weight:900;line-height:1.4}.cart-offer-secured-banner b{color:#ffdf55}' +
      '.boost-cart-flyer{position:fixed;z-index:2147482998;width:96px;height:96px;border:2px solid rgba(255,207,0,.72);border-radius:22px;overflow:hidden;background:#fff;box-shadow:0 22px 50px rgba(3,10,20,.28);pointer-events:none;transform:translate3d(0,0,0) scale(1);opacity:1}.boost-cart-flyer img,.boost-cart-flyer video{width:100%;height:100%;object-fit:cover}.boost-cart-flyer.is-flying{transition:transform .58s cubic-bezier(.2,.82,.2,1),opacity .58s ease,border-radius .58s ease;opacity:.18;border-radius:999px}.boost-cart-pulse{animation:boostCartPulse .46s ease-out}@keyframes boostCartPulse{0%{transform:scale(1)}45%{transform:scale(1.08)}100%{transform:scale(1)}}' +
      '@media(max-width:760px){.cart-item{grid-template-columns:118px minmax(0,1fr)!important;column-gap:12px!important;row-gap:8px!important}.cart-item-price{grid-column:2;min-width:0;max-width:none;text-align:left}.atlas-offer-line-price{align-items:flex-start}.atlas-offer-line-price strong{font-size:15px}.atlas-offer-applied{font-size:8px;padding:4px 7px}.cart-item-image.atlas-cart-media{width:118px!important;height:118px!important;min-width:118px}.cart-item-payment-card{grid-column:1 / -1}}' +
      '@media(max-width:360px){.cart-item{grid-template-columns:104px minmax(0,1fr)!important;column-gap:10px!important}.cart-item-image.atlas-cart-media{width:104px!important;height:104px!important;min-width:104px}}';
    document.head.appendChild(style);
  }

  function getAtlasOfferSessionId(){
    var key = 'atlas-product-offer-session-id';
    try {
      var existing = sessionStorage.getItem(key);
      if (existing) return existing;
      var created = window.crypto && window.crypto.randomUUID
        ? window.crypto.randomUUID()
        : 'shop-' + Date.now() + '-' + Math.random().toString(16).slice(2);
      sessionStorage.setItem(key, created);
      return created;
    } catch(_) {
      return 'shop-' + Date.now() + '-' + Math.random().toString(16).slice(2);
    }
  }

  function isAtlasPreview(){
    return Boolean(
      (window.Shopify && (window.Shopify.designMode || window.Shopify.visualPreviewMode)) ||
      (window.Shopify && window.Shopify.theme && window.Shopify.theme.role && window.Shopify.theme.role !== 'main') ||
      document.querySelector('iframe[src*="shopifycloud/preview-bar"],iframe[src*="/preview-bar/"]') ||
      /(?:preview_theme_id|_ab=|preview=true)/i.test(window.location.search || '')
    );
  }

  function recordAtlasOfferEvent(ruleId, eventType){
    if (!ruleId || ['presented','dismissed','accepted'].indexOf(eventType) === -1) return;
    fetch(atlasOfferEventEndpoint, {
      method: 'POST',
      headers: {'Content-Type':'application/json'},
      keepalive: true,
      body: JSON.stringify({
        action: 'track_product_offer_event',
        payload: {
          rule_id: String(ruleId),
          event_type: eventType,
          session_id: getAtlasOfferSessionId(),
          is_test_data: isAtlasPreview()
        }
      })
    }).catch(function(){});
  }

  function cacheAtlasOfferExperience(config){
    if (!config || !config.ruleId) return;
    try {
      sessionStorage.setItem('atlas-offer-experience-' + config.ruleId, JSON.stringify({
        reelUrl: String(config.reelUrl || ''),
        addOnTitle: String(config.addOnTitle || ''),
        addOnImage: String(config.addOnImage || ''),
        triggerTitle: String(config.triggerTitle || ''),
        triggerCategory: String(config.triggerCategory || ''),
        discountPercent: Number(config.discountPercent || 0),
        savingsCents: Number(config.savingsCents || 0)
      }));
    } catch(_){}
  }

  function readAtlasOfferExperience(ruleId){
    if (!ruleId) return null;
    try {
      var stored = sessionStorage.getItem('atlas-offer-experience-' + ruleId);
      return stored ? JSON.parse(stored) : null;
    } catch(_) {
      return null;
    }
  }

  function cartMediaSettingMeansReels(value){
    var normalized = String(value == null ? 'true' : value).trim().toLowerCase();
    return ['false', '0', 'off', 'image', 'images'].indexOf(normalized) === -1;
  }

  function readStoredAtlasCartMediaSetting(){
    try {
      var stored = JSON.parse(localStorage.getItem(atlasCartMediaSettingStorageKey) || 'null');
      if (!stored || typeof stored.enabled !== 'boolean') return null;
      if (Date.now() - Number(stored.cachedAt || 0) > 60000) return null;
      return stored.enabled;
    } catch(_) {
      return null;
    }
  }

  function saveStoredAtlasCartMediaSetting(enabled){
    try {
      localStorage.setItem(atlasCartMediaSettingStorageKey, JSON.stringify({
        enabled:Boolean(enabled),
        cachedAt:Date.now()
      }));
    } catch(_){}
  }

  function loadAtlasCartMediaSetting(force){
    if (atlasCartMediaSettingRequest) return atlasCartMediaSettingRequest;
    if (!force && atlasCartMediaSettingLoaded) return Promise.resolve(false);

    atlasCartMediaSettingRequest = fetch(atlasOfferEventEndpoint, {
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify({
        action:'settings',
        payload:{keys:['storefront_product_offer_cart_reels_enabled']}
      })
    })
      .then(function(response){
        if (!response.ok) throw new Error('cart media setting unavailable');
        return response.json();
      })
      .then(function(result){
        var rows = result && Array.isArray(result.rows) ? result.rows : [];
        var row = rows.find(function(candidate){
          return candidate &&
            candidate.setting_key === 'storefront_product_offer_cart_reels_enabled';
        });
        var nextEnabled = cartMediaSettingMeansReels(row && row.setting_value);
        var changed = nextEnabled !== atlasCartReelsEnabled;
        atlasCartReelsEnabled = nextEnabled;
        atlasCartMediaSettingLoaded = true;
        saveStoredAtlasCartMediaSetting(nextEnabled);
        return changed;
      })
      .catch(function(){
        atlasCartMediaSettingLoaded = true;
        return false;
      })
      .then(function(changed){
        atlasCartMediaSettingRequest = null;
        return changed;
      });

    return atlasCartMediaSettingRequest;
  }

  function openDrawer(options){
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.classList.add('has-cart-open');
    document.body.style.overflow = 'hidden';
    var refreshPromise = refresh(options);
    loadAtlasCartMediaSetting(true).then(function(changed){
      if (changed && drawer.classList.contains('is-open')) refresh(options);
    });
    return refreshPromise;
  }
  function closeDrawer(){
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.body.classList.remove('has-cart-open');
    document.body.style.overflow = '';
    pauseAtlasCartReels();
  }
  window.Boost = window.Boost || {};
  Boost.openCart = openDrawer;
  Boost.closeCart = closeDrawer;

  function findCartTarget(){
    return document.querySelector('[data-cart-open]') ||
      document.querySelector('.header__cart, .cart-count-bubble, a[href="/cart"]');
  }

  function findAddAnimationSource(btn){
    if (!btn) return null;
    var modal = btn.closest && btn.closest('.cao-modal');
    if (modal) {
      return modal.querySelector('.cao-video video, .cao-image img, .cao-product-hero img');
    }
    var productForm = btn.closest && btn.closest('[data-bpdp-form]');
    var scope = productForm && productForm.closest
      ? productForm.closest('main, section, [data-bpdp-root], body')
      : document;
    return scope.querySelector(
      '[data-bpdp-media-type="video"] video, [data-bpdp-media-type="video"][data-bpdp-media-src], .product-gallery video, .product-gallery img, .product__media video, .product__media img, img[src*="/products/"], img[src*="/cdn/shop/"]',
    );
  }

  function cloneFlyerMedia(source){
    if (!source) return null;
    var tag = String(source.tagName || '').toLowerCase();
    var clone;
    if (tag === 'video') {
      clone = document.createElement('video');
      clone.muted = true;
      clone.loop = true;
      clone.playsInline = true;
      clone.autoplay = true;
      clone.src = source.currentSrc || source.src || '';
      if (source.poster) clone.poster = source.poster;
    } else if (source.dataset && source.dataset.bpdpMediaSrc) {
      clone = document.createElement('video');
      clone.muted = true;
      clone.loop = true;
      clone.playsInline = true;
      clone.autoplay = true;
      clone.src = source.dataset.bpdpMediaSrc;
    } else {
      clone = document.createElement('img');
      clone.alt = '';
      clone.src = source.currentSrc || source.src || '';
    }
    return clone && (clone.src || clone.poster) ? clone : null;
  }

  function playCartAddChime(){
    try {
      var AudioContextCtor = window.AudioContext || window.webkitAudioContext;
      if (!AudioContextCtor) return;
      var context = new AudioContextCtor();
      var oscillator = context.createOscillator();
      var gain = context.createGain();
      oscillator.type = 'sine';
      oscillator.frequency.setValueAtTime(640, context.currentTime);
      oscillator.frequency.exponentialRampToValueAtTime(980, context.currentTime + 0.08);
      gain.gain.setValueAtTime(0.0001, context.currentTime);
      gain.gain.exponentialRampToValueAtTime(0.045, context.currentTime + 0.012);
      gain.gain.exponentialRampToValueAtTime(0.0001, context.currentTime + 0.12);
      oscillator.connect(gain);
      gain.connect(context.destination);
      oscillator.start();
      oscillator.stop(context.currentTime + 0.13);
      oscillator.onended = function(){ context.close && context.close(); };
    } catch(_){}
  }

  function animateProductToCart(btn){
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var source = findAddAnimationSource(btn);
    var target = findCartTarget();
    if (reduceMotion || !source || !target) return Promise.resolve();
    var sourceBox = source.getBoundingClientRect();
    var targetBox = target.getBoundingClientRect();
    if (!sourceBox.width || !sourceBox.height || !targetBox.width || !targetBox.height) return Promise.resolve();
    var media = cloneFlyerMedia(source);
    if (!media) return Promise.resolve();
    var flyer = document.createElement('div');
    flyer.className = 'boost-cart-flyer';
    var size = Math.min(104, Math.max(72, Math.min(sourceBox.width, sourceBox.height)));
    flyer.style.width = size + 'px';
    flyer.style.height = size + 'px';
    flyer.style.left = (sourceBox.left + sourceBox.width / 2 - size / 2) + 'px';
    flyer.style.top = (sourceBox.top + sourceBox.height / 2 - size / 2) + 'px';
    flyer.appendChild(media);
    document.body.appendChild(flyer);
    if (media.play) media.play().catch(function(){});
    var dx = targetBox.left + targetBox.width / 2 - (sourceBox.left + sourceBox.width / 2);
    var dy = targetBox.top + targetBox.height / 2 - (sourceBox.top + sourceBox.height / 2);
    window.requestAnimationFrame(function(){
      flyer.classList.add('is-flying');
      flyer.style.transform = 'translate3d(' + dx + 'px,' + dy + 'px,0) scale(.28) rotate(4deg)';
    });
    target.classList.add('boost-cart-pulse');
    window.setTimeout(function(){ target.classList.remove('boost-cart-pulse'); }, 520);
    return new Promise(function(resolve){
      window.setTimeout(function(){
        flyer.remove();
        resolve();
      }, 610);
    });
  }

  document.addEventListener('click', function(e){
    var openBtn = e.target.closest('[data-cart-open]');
    if (openBtn) { e.preventDefault(); openDrawer(); return; }
    var closeBtn = e.target.closest('[data-cart-close]');
    if (closeBtn) { e.preventDefault(); closeDrawer(); return; }
    var addBtn = e.target.closest('[data-add-to-cart]');
    if (addBtn) { e.preventDefault(); addToCart(addBtn); return; }
    var paySwitch = e.target.closest('[data-cart-payment-switch]');
    if (paySwitch) { e.preventDefault(); switchPaymentVariant(paySwitch); return; }
    var rmBtn = e.target.closest('[data-cart-remove]');
    if (rmBtn) { e.preventDefault(); removeLine(rmBtn.dataset.cartRemove); return; }
    var qtyBtn = e.target.closest('[data-cart-line-qty]');
    if (qtyBtn) { e.preventDefault(); updateQty(qtyBtn.dataset.line, qtyBtn.dataset.cartLineQty); return; }
    var atlasBrochureOpen = e.target.closest('[data-cao-brochure-open]');
    if (atlasBrochureOpen) { e.preventDefault(); openAtlasOfferBrochure(atlasBrochureOpen); return; }
    var atlasBrochureClose = e.target.closest('[data-cao-brochure-close]');
    if (atlasBrochureClose) { e.preventDefault(); closeAtlasOfferBrochure(true); return; }
    var atlasBrochureNav = e.target.closest('[data-cao-brochure-nav]');
    if (atlasBrochureNav) {
      e.preventDefault();
      moveAtlasOfferBrochure(atlasBrochureNav, parseInt(atlasBrochureNav.dataset.caoBrochureNav || '0', 10));
      return;
    }
    var atlasBrochureChoice = e.target.closest('[data-cao-brochure-choice]');
    if (atlasBrochureChoice) {
      e.preventDefault();
      showAtlasOfferBrochure(
        atlasBrochureChoice.closest('[data-cao-brochure-viewer]'),
        parseInt(atlasBrochureChoice.dataset.caoBrochureChoice || '0', 10),
      );
      return;
    }
    var atlasOfferVariantChoice = e.target.closest('[data-cao-variant-choice]');
    if (atlasOfferVariantChoice) {
      e.preventDefault();
      selectAtlasOfferVariant(atlasOfferVariantChoice);
      return;
    }
    var atlasOfferAdd = e.target.closest('[data-atlas-offer-add]');
    if (atlasOfferAdd) { e.preventDefault(); addAtlasOffer(atlasOfferAdd); return; }
    var atlasOfferDecline = e.target.closest('[data-atlas-offer-decline]');
    if (atlasOfferDecline) { e.preventDefault(); declineAtlasOffer(atlasOfferDecline); return; }
    var bundleAdd = e.target.closest('[data-bundle-add]');
    if (bundleAdd) { e.preventDefault(); addToCart(bundleAdd); return; }
  });
  document.addEventListener('keydown', function(e){
    var offerModal = document.querySelector('[data-cart-atlas-offer]:not([hidden])');
    if (offerModal) {
      var brochureViewer = offerModal.querySelector('[data-cao-brochure-viewer]:not([hidden])');
      if (brochureViewer) {
        if (e.key === 'Escape') {
          e.preventDefault();
          closeAtlasOfferBrochure(true);
          return;
        }
        if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
          e.preventDefault();
          moveAtlasOfferBrochure(
            brochureViewer,
            e.key === 'ArrowLeft' ? -1 : 1,
          );
          return;
        }
        if (e.key === 'Tab') trapAtlasOfferFocus(e, brochureViewer);
        return;
      }
      if (e.key === 'Escape') {
        e.preventDefault();
        var decline = offerModal.querySelector('[data-atlas-offer-decline]');
        if (decline) declineAtlasOffer(decline);
        return;
      }
      if (e.key === 'Tab') trapAtlasOfferFocus(e, offerModal);
      return;
    }
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
  });
  overlay.addEventListener('click', closeDrawer);

  function addToCart(btn){
    var variantId = btn.dataset.variantId;
    if (!variantId) return;
    var qty = parseInt(btn.dataset.qty || '1', 10);
    var fd = new FormData();
    fd.append('id', variantId);
    fd.append('quantity', qty);
    fetch('/cart/add.js', {method:'POST', body:fd, headers:{'Accept':'application/json'}}).then(function(r){
      if (!r.ok) return r.json().catch(function(){return {};}).then(function(payload){throw new Error(payload.description || 'Could not add product');});
      return r.json();
    }).then(function(){
      playCartAddChime();
      return animateProductToCart(btn).then(function(){
        openDrawer({offerTriggerVariantId:String(variantId)});
      });
    }).then(function(){
      document.dispatchEvent(new CustomEvent('boost:cart:added', {detail:{variantId:variantId, quantity:qty}}));
    }).catch(function(err){
      console.warn('cart add failed', err);
      if (window.Boost && window.Boost.toast) window.Boost.toast('<span class="boost-toast-icon">!</span> Could not add to cart. Try again or WhatsApp us.', 'error');
    });
  }

  function addAtlasOffer(btn){
    if (btn.disabled) return;
    var currentVariantInput = document.querySelector('[data-bpdp-variant-input]');
    var isCartOffer = btn.dataset.atlasOfferSource === 'cart';
    var triggerVariantId = isCartOffer
      ? btn.dataset.triggerVariantId
      : currentVariantInput && currentVariantInput.value
        ? currentVariantInput.value
        : btn.dataset.triggerVariantId;
    var addOnVariantId = btn.dataset.addOnVariantId;
    var ruleId = btn.dataset.offerRuleId;
    var expiry = btn.dataset.offerExpires;
    var addOnLabel = btn.dataset.addOnLabel || 'item';
    if (!triggerVariantId || !addOnVariantId || !ruleId) return;
    if (expiry && new Date(expiry).getTime() <= Date.now()) {
      var expiredOffer = btn.closest('[data-atlas-add-on-offer]');
      if (expiredOffer) expiredOffer.hidden = true;
      if (window.Boost && window.Boost.toast) window.Boost.toast('<span class="boost-toast-icon">!</span> This offer has expired.', 'error');
      return;
    }

    var originalLabel = btn.textContent;
    btn.disabled = true;
    btn.textContent = isCartOffer ? 'Adding ' + addOnLabel + '…' : 'Adding both…';
    fetch('/cart.js', {headers:{'Accept':'application/json'}})
      .then(function(response){
        if (!response.ok) throw new Error('Could not read cart');
        return response.json();
      })
      .then(function(cart){
        var cartItems = cart.items || [];
        var hasTrigger = cartItems.some(function(item){ return String(item.variant_id) === String(triggerVariantId); });
        var hasAddOn = cartItems.some(function(item){ return String(item.variant_id) === String(addOnVariantId); });
        var items = [];
        if (!hasTrigger) items.push({id:String(triggerVariantId), quantity:1});
        if (!hasAddOn) items.push({
          id:String(addOnVariantId),
          quantity:1,
          properties:{_atlas_offer_rule_id:String(ruleId), _atlas_offer_type:'add_on'}
        });
        if (!items.length) return null;
        return fetch('/cart/add.js', {
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({items:items})
        }).then(function(response){
          if (!response.ok) return response.json().catch(function(){return {};}).then(function(payload){throw new Error(payload.description || 'Could not add this offer');});
          return response.json();
        });
      })
      .then(function(){
        playCartAddChime();
        return animateProductToCart(btn);
      })
      .then(function(){
        closeAtlasOfferModal(false);
        openDrawer();
        recordAtlasOfferEvent(ruleId, 'accepted');
        document.dispatchEvent(new CustomEvent('boost:cart:added', {detail:{variantId:addOnVariantId, quantity:1, offerRuleId:ruleId}}));
        if (isCartOffer && window.Boost && window.Boost.toast) {
          window.Boost.toast('<span class="boost-toast-icon">✓</span> Add-on added. Your offer discount will appear at checkout.', 'success');
        }
      })
      .catch(function(error){
        console.warn('Atlas add-on offer failed', error);
        if (window.Boost && window.Boost.toast) window.Boost.toast('<span class="boost-toast-icon">!</span> Could not add this offer. Please try again or WhatsApp us.', 'error');
      })
      .finally(function(){
        btn.disabled = false;
        btn.textContent = originalLabel;
      });
  }

  function declineAtlasOffer(btn){
    var ruleId = btn.dataset.offerRuleId;
    recordAtlasOfferEvent(ruleId, 'dismissed');
    closeAtlasOfferModal(true);
  }
  function removeLine(line){
    fetch('/cart/change.js', {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({line:parseInt(line,10), quantity:0})}).then(refresh);
  }
  function updateQty(line, q){
    fetch('/cart/change.js', {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({line:parseInt(line,10), quantity:parseInt(q,10)})}).then(refresh);
  }

  function refresh(options){
    return fetch('/cart.js', {headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(cart){
      render(cart, options || {});
      // Update header badge
      document.querySelectorAll('[data-cart-count]').forEach(function(el){
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? '' : 'none';
      });
    });
  }
  function fmt(n){
    var amount = Math.round(Number(n || 0)) / 100;
    return 'Rs. ' + amount.toLocaleString('en-PK', {
      minimumFractionDigits: Number.isInteger(amount) ? 0 : 2,
      maximumFractionDigits: 2
    });
  }

  function parseAtlasOfferConfig(root){
    if (!root) return null;
    var node = root.querySelector('[data-atlas-add-on-config]');
    if (!node) return null;
    try {
      var config = JSON.parse(node.textContent || '{}');
      if (config && config.ruleId) {
        config.addOnChoices = normaliseAtlasOfferChoices(config);
      }
      return config && config.ruleId ? config : null;
    } catch(error) {
      console.warn('Atlas offer config could not be read', error);
      return null;
    }
  }

  function normaliseAtlasOfferChoices(config){
    var rawChoices = Array.isArray(config && config.addOnChoices)
      ? config.addOnChoices
      : [];
    var choices = rawChoices.map(function(choice){
      if (!choice) return null;
      var originalCents = Math.round(Number(choice.original_price_pkr || 0) * 100);
      var discountedCents = Math.round(Number(choice.discounted_price_pkr || 0) * 100);
      var savingsCents = Math.round(Number(choice.savings_pkr || 0) * 100);
      return {
        variantId:String(choice.variant_id || ''),
        productId:String(choice.shopify_product_id || ''),
        handle:String(choice.handle || config.addOnHandle || ''),
        title:String(choice.title || config.addOnTitle || 'Add-on product'),
        colorLabel:String(choice.color_label || choice.title || 'Option'),
        image:String(choice.image || config.addOnImage || ''),
        originalCents:originalCents || Number(config.originalCents || 0),
        discountedCents:discountedCents || Number(config.discountedCents || 0),
        savingsCents:savingsCents || Number(config.savingsCents || 0)
      };
    }).filter(function(choice){ return choice && choice.variantId; });
    if (!choices.length && config && config.addOnVariantId) {
      choices.push({
        variantId:String(config.addOnVariantId),
        productId:String(config.addOnProductId || ''),
        handle:String(config.addOnHandle || ''),
        title:String(config.addOnTitle || 'Add-on product'),
        colorLabel:String(config.addOnTitle || 'Option'),
        image:String(config.addOnImage || ''),
        originalCents:Number(config.originalCents || 0),
        discountedCents:Number(config.discountedCents || 0),
        savingsCents:Number(config.savingsCents || 0)
      });
    }
    return choices;
  }

  function atlasOfferIsCurrent(config){
    if (!config || !config.ruleId || !config.triggerProductId || !config.addOnVariantId) return false;
    var now = Date.now();
    var startsAt = Date.parse(config.startsAt || '');
    var endsAt = Date.parse(config.endsAt || '');
    if (Number.isFinite(startsAt) && startsAt > now) return false;
    if (Number.isFinite(endsAt) && endsAt <= now) return false;
    return true;
  }

  function cartHasProduct(cart, productId){
    return (cart.items || []).some(function(item){
      return String(item.product_id) === String(productId);
    });
  }

  function cartHasAtlasOfferChoice(cart, config){
    var productIds = (Array.isArray(config && config.addOnChoices)
      ? config.addOnChoices
      : [])
      .map(function(choice){ return String(choice.productId || ''); })
      .filter(Boolean);
    if (!productIds.length && config && config.addOnProductId) {
      productIds.push(String(config.addOnProductId));
    }
    return (cart.items || []).some(function(item){
      return productIds.indexOf(String(item.product_id)) >= 0;
    });
  }

  function cartTriggerItem(cart, config){
    return (cart.items || []).find(function(item){
      return String(item.product_id) === String(config.triggerProductId);
    });
  }

  function atlasOfferFeatureKey(value){
    return String(value || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function atlasOfferProductKind(value){
    var normalized = String(value || '').toLowerCase();
    if (/headset|headphone|earbud|earphone/.test(normalized)) return 'headset';
    if (/chair|seat/.test(normalized)) return 'chair';
    if (/smart[\s-]?watch|\bwatch\b/.test(normalized)) return 'watch';
    if (/keyboard/.test(normalized)) return 'keyboard';
    if (/\bmouse\b/.test(normalized)) return 'mouse';
    if (/speaker|soundbar/.test(normalized)) return 'speaker';
    if (/power[\s-]?bank|charger/.test(normalized)) return 'charger';
    if (/cooler|fan/.test(normalized)) return 'cooling product';
    return '';
  }

  function atlasOfferTriggerContext(config){
    var kind = atlasOfferProductKind(
      String((config && config.triggerCategory) || '') + ' ' +
      String((config && config.triggerTitle) || '')
    );
    if (!kind) {
      return {
        eyebrow:'THIS PURCHASE',
        noun:'purchase',
        possessive:'your order'
      };
    }
    return {
      eyebrow:'YOUR ' + kind.toUpperCase(),
      noun:kind,
      possessive:'your ' + kind
    };
  }

  function buildAtlasOfferFeatures(config){
    var titleLower = String(config.addOnTitle || '').toLowerCase();
    var triggerContext = atlasOfferTriggerContext(config);
    var defaults = titleLower.indexOf('watch') >= 0
      ? ['Bluetooth calling', 'Health tracking', '1-year warranty', 'Ships with ' + triggerContext.possessive]
      : ['Ships together', 'Protected offer price', 'Easy checkout', 'Limited-time saving'];
    var features = [];
    var seen = {};
    var candidates = (Array.isArray(config.features) ? config.features : []).concat(defaults);
    candidates.forEach(function(feature){
      var label = String(feature || '').trim();
      var key = atlasOfferFeatureKey(label);
      if (!key || seen[key] || features.length >= 4) return;
      seen[key] = true;
      features.push(label);
    });
    return features;
  }

  function loadAtlasOfferForHandle(handle){
    if (!handle) return Promise.resolve(null);
    if (Object.prototype.hasOwnProperty.call(atlasOfferConfigCache, handle)) {
      return validateAtlasOfferConfig(atlasOfferConfigCache[handle]);
    }
    return fetch('/products/' + encodeURIComponent(handle), {
      headers:{'Accept':'text/html'}
    })
      .then(function(response){
        if (!response.ok) return null;
        return response.text();
      })
      .then(function(html){
        if (!html) return null;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return parseAtlasOfferConfig(doc);
      })
      .catch(function(){ return null; })
      .then(function(config){
        return validateAtlasOfferConfig(config);
      })
      .then(function(validatedConfig){
        atlasOfferConfigCache[handle] = validatedConfig;
        return validatedConfig;
      });
  }

  function validateAtlasOfferConfig(config){
    if (!atlasOfferIsCurrent(config)) return Promise.resolve(null);
    var claimKey = [
      config.ruleId,
      config.triggerProductId,
      config.addOnVariantId,
      config.discountPercent,
      config.startsAt || '',
      config.endsAt || ''
    ].join('|');
    var cached = atlasOfferValidationCache[claimKey];
    if (cached && cached.expiresAt > Date.now()) return cached.promise;
    var request = fetch(atlasOfferEventEndpoint, {
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({
        action:'validate_product_offer_configuration',
        payload:{
          rule_id:String(config.ruleId || ''),
          trigger_shopify_product_id:String(config.triggerProductId || ''),
          add_on_shopify_variant_id:String(config.addOnVariantId || ''),
          discount_percent:Number(config.discountPercent || 0),
          starts_at:config.startsAt || null,
          expires_at:config.endsAt || null
        }
      })
    })
      .then(function(response){
        if (!response.ok) return null;
        return response.json();
      })
      .then(function(payload){ return payload && payload.valid === true ? config : null; })
      .catch(function(){ return null; });
    atlasOfferValidationCache[claimKey] = {
      expiresAt:Date.now() + 10000,
      promise:request
    };
    return request;
  }

  function findAtlasOfferForCart(cart){
    var inlineConfig = parseAtlasOfferConfig(document);
    var inlineCandidate = (
      atlasOfferIsCurrent(inlineConfig) &&
      cartTriggerItem(cart, inlineConfig) &&
      !cartHasAtlasOfferChoice(cart, inlineConfig)
    ) ? inlineConfig : null;

    var seenHandles = {};
    var handles = (cart.items || []).map(function(item){
      var handle = item.handle || String(item.url || '').split('/products/').pop().split('?')[0];
      if (!handle || seenHandles[handle]) return null;
      seenHandles[handle] = true;
      return handle;
    }).filter(Boolean);

    return validateAtlasOfferConfig(inlineCandidate).then(function(validInline){
      if (validInline) return validInline;
      return Promise.all(handles.map(loadAtlasOfferForHandle)).then(function(configs){
        return configs.find(function(config){
          return atlasOfferIsCurrent(config) &&
            cartTriggerItem(cart, config) &&
            !cartHasAtlasOfferChoice(cart, config);
        }) || null;
      });
    });
  }

  function ensureAtlasOfferSlot(){
    var existing = document.querySelector('[data-cart-atlas-offer]');
    if (existing) return existing;
    var slot = document.createElement('div');
    slot.setAttribute('data-cart-atlas-offer', '');
    slot.className = 'cao-layer';
    slot.hidden = true;
    document.body.appendChild(slot);
    ensureAtlasOfferStyles();
    return slot;
  }

  function ensureAtlasOfferStyles(){
    if (document.getElementById('atlas-cart-offer-styles')) return;
    var style = document.createElement('style');
    style.id = 'atlas-cart-offer-styles';
    style.textContent =
      '.cao-layer,.cao-layer *{box-sizing:border-box}.cao-layer[hidden]{display:none!important}.cao-layer{position:fixed;inset:0;z-index:2147483000;display:grid;place-items:center;padding:20px}' +
      '.cao-backdrop{position:absolute;inset:0;border:0;background:rgba(3,10,20,.78);backdrop-filter:blur(7px);cursor:pointer}' +
      '.cao-modal{position:relative;width:min(980px,100%);max-height:min(880px,calc(100vh - 40px));overflow:auto;border:1px solid rgba(226,182,0,.72);border-radius:26px;background:#fff;color:#0b1f3a;box-shadow:0 32px 90px rgba(0,0,0,.42)}' +
      '.cao-topline{height:6px;background:linear-gradient(90deg,#ffcf00,#f59e0b 48%,#ffcf00)}.cao-close{position:absolute;z-index:2;top:20px;right:20px;width:46px;height:46px;border:1px solid #dce2ea;border-radius:999px;background:#fff;color:#0b1f3a;font-size:27px;line-height:1;cursor:pointer;box-shadow:0 8px 22px rgba(11,31,58,.14)}' +
      '.cao-grid{display:grid;grid-template-columns:minmax(0,.95fr) minmax(0,1.05fr);align-items:stretch}.cao-media{display:flex;min-width:0;min-height:100%;flex-direction:column;padding:26px;background:linear-gradient(150deg,#071426 0%,#102844 100%);color:#fff}.cao-content{min-width:0;padding:38px 38px 34px}' +
      '.cao-video,.cao-product-hero{width:100%;aspect-ratio:16/11;border:1px solid rgba(255,255,255,.16);border-radius:20px;background:#02060c;overflow:hidden;display:flex;align-items:center;justify-content:center}.cao-video video{width:100%;height:100%;object-fit:cover}.cao-product-hero img{width:100%;height:100%;object-fit:contain;background:#fff}.cao-media-label{display:flex;align-items:center;justify-content:space-between;gap:12px;margin-bottom:12px;font-size:11px;font-weight:900;letter-spacing:.12em;color:#ffdf55}.cao-media-label span:last-child{color:#c6d0db;font-weight:700;letter-spacing:0}' +
      '.cao-brochure-label{display:flex;align-items:center;justify-content:space-between;gap:12px;margin:18px 0 9px;color:#ffdf55;font-size:10px;font-weight:900;letter-spacing:.11em}.cao-brochure-label span:last-child{color:#c6d0db;font-size:10px;font-weight:700;letter-spacing:0}.cao-brochures{display:grid;grid-template-columns:1fr;grid-auto-rows:minmax(150px,1fr);flex:1;gap:11px;min-height:330px}.cao-brochure{position:relative;display:block;width:100%;min-height:150px;padding:0;overflow:hidden;border:1px solid rgba(255,255,255,.24);border-radius:15px;background:#fff;cursor:zoom-in;text-align:left}.cao-brochure:after{content:"";position:absolute;inset:auto 0 0;height:36%;background:linear-gradient(180deg,transparent,rgba(3,10,20,.92));pointer-events:none}.cao-brochure img{display:block;width:100%;height:100%;background:#fff;object-fit:contain;transition:transform .2s ease}.cao-brochure:hover img{transform:scale(1.015)}.cao-brochure-index{position:absolute;z-index:1;left:10px;bottom:10px;border-radius:999px;background:rgba(3,10,20,.88);color:#fff;padding:6px 9px;font-size:9px;font-weight:850}.cao-brochure-zoom{position:absolute;z-index:1;top:10px;right:10px;display:grid;place-items:center;width:34px;height:34px;border-radius:999px;background:rgba(255,255,255,.96);color:#071426;box-shadow:0 5px 14px rgba(0,0,0,.22)}.cao-brochure-zoom svg{width:16px;height:16px}.cao-brochure-view{position:absolute;z-index:1;right:11px;bottom:11px;color:#fff;font-size:9px;font-weight:850}.cao-media-note{margin:13px 0 0;color:#c6d0db;font-size:11px;line-height:1.5}' +
      '.cao-eyebrow{display:inline-flex;align-items:center;min-height:30px;border-radius:999px;background:#fff1b8;color:#654d00;padding:7px 11px;font-size:10px;font-weight:950;letter-spacing:.11em}.cao-content h2{margin:15px 54px 7px 0;color:#071426;font-size:clamp(28px,3.4vw,44px);line-height:1.02;letter-spacing:-.035em}.cao-subtitle{margin:0;color:#526174;font-size:13px;line-height:1.55}.cao-social-proof{display:flex;align-items:flex-start;gap:9px;margin-top:13px;border:1px solid #f1df9f;border-radius:13px;background:#fff9df;color:#594600;padding:10px 12px;font-size:11px;font-weight:800;line-height:1.45}.cao-social-proof:before{content:"★";flex:0 0 auto;color:#d79b00;font-size:14px}.cao-gift-prompt{display:flex;align-items:center;gap:9px;margin-top:9px;border:1px solid rgba(226,182,0,.72);border-radius:13px;background:linear-gradient(135deg,#fffdf2 0%,#fff3be 100%);color:#4d3a00;padding:10px 12px;font-size:11px;font-weight:850;line-height:1.45;box-shadow:0 0 0 0 rgba(226,182,0,0);animation:caoGiftGlow 3.6s ease-in-out infinite}.cao-gift-prompt>span:first-child{flex:0 0 auto;font-size:17px;filter:drop-shadow(0 2px 3px rgba(122,83,0,.18))}.cao-product{display:grid;grid-template-columns:78px minmax(0,1fr);gap:14px;align-items:center;margin-top:20px;border:1px solid #e6eaf0;border-radius:17px;background:#f8fafc;padding:13px}.cao-image{width:78px;height:78px;border:1px solid #e2e7ed;border-radius:13px;background:#fff;overflow:hidden;display:flex;align-items:center;justify-content:center}.cao-image img{width:100%;height:100%;object-fit:contain}.cao-copy{min-width:0}.cao-copy strong{display:block;color:#071426;font-size:16px;line-height:1.25}.cao-copy p{margin:5px 0 0;color:#526174;font-size:11px;line-height:1.45}' +
      '.cao-choice-wrap{margin-top:15px}.cao-choice-label{display:flex;align-items:center;justify-content:space-between;gap:10px;margin:0 0 8px;color:#071426;font-size:11px;font-weight:900}.cao-choice-label span{color:#64748b;font-size:10px;font-weight:750}.cao-choices{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:8px}.cao-choice{display:grid;grid-template-columns:38px minmax(0,1fr);gap:8px;align-items:center;min-height:54px;padding:7px;border:1px solid #dce2ea;border-radius:13px;background:#fff;color:#071426;cursor:pointer;text-align:left}.cao-choice[aria-checked="true"]{border:2px solid #e6b800;background:#fff9df;box-shadow:0 0 0 2px rgba(255,207,0,.14)}.cao-choice img{width:38px;height:38px;border-radius:9px;background:#f8fafc;object-fit:contain}.cao-choice strong{display:block;overflow:hidden;font-size:10px;line-height:1.2;text-overflow:ellipsis;white-space:nowrap}.cao-choice small{display:block;margin-top:3px;color:#64748b;font-size:9px;font-weight:700}.cao-choice:focus-visible{outline:3px solid #d4af37;outline-offset:2px}' +
      '.cao-features{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:7px;margin-top:14px}.cao-feature{position:relative;border-radius:11px;background:#f3f6f9;color:#36506b;padding:9px 9px 9px 28px;font-size:10px;font-weight:800;line-height:1.35}.cao-feature:before{content:"✓";position:absolute;left:10px;color:#068358;font-weight:950}.cao-pricing{margin-top:18px;border-radius:17px;background:#071426;color:#fff;padding:17px}.cao-price{display:flex;align-items:baseline;flex-wrap:wrap;gap:9px}.cao-price b{font-size:30px;line-height:1}.cao-price s{color:#aeb9c5;font-size:13px}.cao-save{display:inline-flex;margin-top:10px;border-radius:999px;background:#d9fbe7;color:#067647;padding:7px 10px;font-size:11px;font-weight:950}.cao-countdown{margin-top:12px;border:2px solid #f59e0b;border-radius:13px;background:#fff7ed;color:#9a3412;padding:10px;text-align:center;font-size:12px;font-weight:950;font-variant-numeric:tabular-nums}' +
      '.cao-proof{margin:12px 0 0;color:#526174;font-size:11px;line-height:1.5}.cao-details{display:inline-flex;margin-top:9px;color:#0b5aa5;font-size:11px;font-weight:850;text-decoration:underline;text-underline-offset:3px}.cao-actions{display:grid;grid-template-columns:minmax(0,1fr) auto;gap:10px;margin-top:18px}.cao-add,.cao-decline{min-height:54px;border-radius:14px;font-size:13px;font-weight:950;cursor:pointer}.cao-add{border:0;background:#ffcf00;color:#071426;padding:12px 18px;box-shadow:0 10px 24px rgba(226,182,0,.30)}.cao-add:hover{background:#ffdc45;transform:translateY(-1px)}.cao-decline{border:1px solid #cfd6df;background:#fff;color:#526174;padding:11px 16px}.cao-close:focus-visible,.cao-backdrop:focus-visible,.cao-add:focus-visible,.cao-decline:focus-visible,.cao-details:focus-visible,.cao-brochure:focus-visible{outline:3px solid #d4af37;outline-offset:3px}.cao-add:disabled{cursor:not-allowed;opacity:.65}' +
      '.cao-lightbox[hidden]{display:none!important}.cao-lightbox{position:fixed;inset:0;z-index:2147483002;display:grid;place-items:center;padding:18px}.cao-lightbox-backdrop{position:absolute;inset:0;border:0;background:rgba(1,7,15,.94);backdrop-filter:blur(9px);cursor:pointer}.cao-lightbox-dialog{position:relative;display:grid;grid-template-columns:minmax(0,1fr) 292px;width:min(1180px,100%);height:min(900px,calc(100dvh - 36px));overflow:hidden;border:1px solid rgba(255,207,0,.70);border-radius:25px;background:#fff;color:#071426;box-shadow:0 34px 100px rgba(0,0,0,.58)}.cao-lightbox-stage{position:relative;display:flex;min-width:0;min-height:0;flex-direction:column;padding:22px;background:linear-gradient(145deg,#061326,#0d2947);color:#fff}.cao-lightbox-kicker{margin:0 68px 12px 0;color:#ffdf55;font-size:11px;font-weight:950;letter-spacing:.13em}.cao-lightbox-image-wrap{display:flex;min-width:0;min-height:0;flex:1;align-items:center;justify-content:center;overflow:hidden;border:1px solid rgba(255,255,255,.14);border-radius:18px;background:#02060c}.cao-lightbox-image{display:block;width:100%;height:100%;object-fit:contain}.cao-lightbox-count{margin:12px 0 0;color:#cbd5e1;font-size:11px;font-weight:800;text-align:center}.cao-lightbox-close{position:absolute;z-index:3;top:18px;right:18px;display:grid;place-items:center;width:46px;height:46px;border:1px solid #dce2ea;border-radius:999px;background:#fff;color:#071426;cursor:pointer;box-shadow:0 8px 22px rgba(11,31,58,.20)}.cao-lightbox-close svg,.cao-lightbox-nav svg{width:20px;height:20px}.cao-lightbox-nav{position:absolute;z-index:2;top:50%;display:grid;place-items:center;width:48px;height:48px;margin-top:-24px;border:1px solid rgba(255,255,255,.42);border-radius:999px;background:rgba(3,10,20,.82);color:#fff;cursor:pointer;box-shadow:0 8px 22px rgba(0,0,0,.24)}.cao-lightbox-prev{left:34px}.cao-lightbox-next{right:34px}.cao-lightbox-rail{min-width:0;overflow:auto;padding:76px 18px 18px;background:#fff}.cao-lightbox-rail h3{margin:0;color:#071426;font-size:23px;line-height:1.08}.cao-lightbox-rail>p{margin:9px 0 0;color:#526174;font-size:12px;line-height:1.5}.cao-lightbox-thumb-list{display:grid;gap:10px;margin-top:20px}.cao-lightbox-thumb{display:grid;grid-template-columns:76px minmax(0,1fr);gap:11px;align-items:center;width:100%;min-height:92px;padding:7px;border:1px solid #dce2ea;border-radius:14px;background:#f8fafc;color:#071426;cursor:pointer;text-align:left}.cao-lightbox-thumb[aria-current="true"]{border:2px solid #ffcf00;background:#fff9df}.cao-lightbox-thumb img{width:76px;height:76px;border-radius:9px;background:#fff;object-fit:cover}.cao-lightbox-thumb strong{display:block;font-size:12px}.cao-lightbox-thumb span{display:block;margin-top:4px;color:#64748b;font-size:10px;line-height:1.35}.cao-lightbox-back{display:flex;align-items:center;justify-content:center;width:100%;min-height:48px;margin-top:18px;border:0;border-radius:13px;background:#ffcf00;color:#071426;font-size:12px;font-weight:950;cursor:pointer}.cao-lightbox-note{margin-top:16px!important;border-radius:12px;background:#ecfdf3;color:#067647!important;padding:11px;font-size:10px!important;font-weight:800}.cao-lightbox-close:focus-visible,.cao-lightbox-nav:focus-visible,.cao-lightbox-thumb:focus-visible,.cao-lightbox-back:focus-visible{outline:3px solid #ffcf00;outline-offset:3px}' +
      '@media(max-width:760px){.cao-choice-wrap{margin-top:10px}.cao-choices{display:flex;overflow-x:auto;padding:2px 2px 5px;scroll-snap-type:x proximity}.cao-choice{flex:0 0 min(170px,72vw);scroll-snap-align:start}}' +
      '@media(max-width:760px){.cao-layer{place-items:end center;padding:0}.cao-backdrop{backdrop-filter:blur(4px)}.cao-modal{width:100%;max-height:96dvh;border-radius:24px 24px 0 0}.cao-grid{display:block}.cao-media{display:block;min-height:0;padding:14px 18px 12px}.cao-media-label{margin-bottom:8px}.cao-video,.cao-product-hero{aspect-ratio:16/7}.cao-brochure-label{margin:10px 0 7px}.cao-brochures{grid-template-columns:repeat(2,minmax(0,1fr));grid-auto-rows:auto;gap:8px;min-height:0}.cao-brochure{min-height:0;aspect-ratio:16/8}.cao-content{padding:17px 18px 20px}.cao-eyebrow{min-height:26px;padding:5px 10px}.cao-content h2{margin:11px 48px 6px 0;font-size:27px}.cao-subtitle{font-size:12px;line-height:1.4}.cao-social-proof{display:none}.cao-gift-prompt{margin-top:9px;padding:8px 10px;font-size:10.5px}.cao-pricing{margin-top:13px;padding:13px}.cao-price b{font-size:27px}.cao-save{margin-top:7px;padding:6px 9px}.cao-countdown{margin-top:8px;padding:8px}.cao-actions{grid-template-columns:minmax(0,1fr) auto;gap:8px;margin-top:10px}.cao-add,.cao-decline{min-height:50px}.cao-add{padding:10px 12px}.cao-decline{min-width:92px;padding:10px}.cao-product{grid-template-columns:58px minmax(0,1fr);margin-top:16px;padding:10px}.cao-image{width:58px;height:58px}.cao-features{grid-template-columns:1fr 1fr;margin-top:10px}.cao-proof{margin-top:10px}.cao-close{top:15px;right:15px;width:44px;height:44px}.cao-lightbox{padding:0}.cao-lightbox-dialog{grid-template-columns:1fr;grid-template-rows:minmax(0,1fr) auto;width:100%;height:100dvh;max-height:none;border:0;border-radius:0}.cao-lightbox-stage{padding:58px 12px 12px}.cao-lightbox-kicker{margin:0 55px 9px 0;font-size:10px}.cao-lightbox-image-wrap{border-radius:14px}.cao-lightbox-count{margin-top:8px}.cao-lightbox-close{top:10px;right:10px;width:44px;height:44px}.cao-lightbox-nav{top:48%;width:44px;height:44px;margin-top:-22px}.cao-lightbox-prev{left:18px}.cao-lightbox-next{right:18px}.cao-lightbox-rail{max-height:235px;padding:13px 12px 12px}.cao-lightbox-rail h3{font-size:17px}.cao-lightbox-rail>p{margin-top:4px;font-size:10px}.cao-lightbox-thumb-list{grid-template-columns:repeat(2,minmax(0,1fr));gap:7px;margin-top:9px}.cao-lightbox-thumb{grid-template-columns:48px minmax(0,1fr);gap:7px;min-height:62px;padding:5px}.cao-lightbox-thumb img{width:48px;height:50px}.cao-lightbox-thumb strong{font-size:10px}.cao-lightbox-thumb span{display:none}.cao-lightbox-back{min-height:46px;margin-top:9px}.cao-lightbox-note{display:none}}' +
      '@media(max-width:420px){.cao-media-label span:last-child{display:none}.cao-media-note{display:none}.cao-content{padding-top:15px}.cao-brochures{gap:7px}.cao-feature{padding-top:7px;padding-bottom:7px}.cao-details{margin-top:7px}}' +
      '@keyframes caoGiftGlow{0%,100%{border-color:rgba(226,182,0,.62);box-shadow:0 0 0 0 rgba(226,182,0,0)}50%{border-color:#e6b800;box-shadow:0 0 0 4px rgba(255,207,0,.14),0 8px 20px rgba(226,182,0,.10)}}' +
      '@media(prefers-reduced-motion:reduce){.cao-add,.cao-brochure img{transition:none}.cao-add:hover{transform:none}.cao-brochure:hover img{transform:none}.cao-video video,.cao-gift-prompt{animation:none}}';
    document.head.appendChild(style);
  }

  function closeAtlasOfferModal(restoreFocus){
    var modal = document.querySelector('[data-cart-atlas-offer]');
    if (atlasOfferTimer) window.clearInterval(atlasOfferTimer);
    atlasOfferTimer = null;
    closeAtlasOfferBrochure(false);
    if (modal) {
      modal.hidden = true;
      modal.innerHTML = '';
    }
    if (restoreFocus && atlasOfferReturnFocus && atlasOfferReturnFocus.focus && document.contains(atlasOfferReturnFocus)) {
      atlasOfferReturnFocus.focus();
    }
    atlasOfferReturnFocus = null;
  }

  function brochureViewerFrom(source){
    if (!source) return null;
    if (source.matches && source.matches('[data-cao-brochure-viewer]')) return source;
    var layer = source.closest ? source.closest('[data-cart-atlas-offer]') : null;
    return layer ? layer.querySelector('[data-cao-brochure-viewer]') : null;
  }

  function showAtlasOfferBrochure(viewer, requestedIndex){
    if (!viewer) return;
    var choices = Array.prototype.slice.call(viewer.querySelectorAll('[data-cao-brochure-choice]'));
    if (!choices.length) return;
    var count = choices.length;
    var index = ((Number.isFinite(requestedIndex) ? requestedIndex : 0) % count + count) % count;
    var choice = choices[index];
    var image = viewer.querySelector('[data-cao-brochure-image]');
    var title = viewer.querySelector('[data-cao-brochure-title]');
    var counter = viewer.querySelector('[data-cao-brochure-count]');
    if (image) {
      image.src = choice.dataset.caoBrochureUrl || '';
      image.alt = choice.dataset.caoBrochureAlt || 'Product information card';
    }
    if (title) title.textContent = choice.dataset.caoBrochureTitle || 'Product information';
    if (counter) counter.textContent = 'Information card ' + (index + 1) + ' of ' + count;
    choices.forEach(function(item, itemIndex){
      item.setAttribute('aria-current', itemIndex === index ? 'true' : 'false');
    });
    viewer.dataset.caoBrochureIndex = String(index);
  }

  function moveAtlasOfferBrochure(source, direction){
    var viewer = brochureViewerFrom(source);
    if (!viewer) return;
    var currentIndex = parseInt(viewer.dataset.caoBrochureIndex || '0', 10);
    showAtlasOfferBrochure(viewer, currentIndex + (Number.isFinite(direction) ? direction : 0));
  }

  function openAtlasOfferBrochure(button){
    var viewer = brochureViewerFrom(button);
    if (!viewer) return;
    atlasOfferBrochureReturnFocus = button;
    atlasOfferBrochureParent = button.closest('.cao-modal');
    atlasOfferBrochureScrollTop = atlasOfferBrochureParent ? atlasOfferBrochureParent.scrollTop : 0;
    atlasOfferBrochureVideo = atlasOfferBrochureParent ? atlasOfferBrochureParent.querySelector('video') : null;
    atlasOfferBrochureVideoWasPlaying = !!(atlasOfferBrochureVideo && !atlasOfferBrochureVideo.paused);
    if (atlasOfferBrochureVideoWasPlaying) atlasOfferBrochureVideo.pause();
    if (atlasOfferBrochureParent) {
      atlasOfferBrochureParent.setAttribute('inert', '');
      atlasOfferBrochureParent.setAttribute('aria-hidden', 'true');
    }
    viewer.hidden = false;
    showAtlasOfferBrochure(viewer, parseInt(button.dataset.caoBrochureOpen || '0', 10));
    window.setTimeout(function(){
      var close = viewer.querySelector('[data-cao-brochure-close]');
      if (close) close.focus();
    }, 0);
  }

  function closeAtlasOfferBrochure(restoreFocus){
    var viewer = document.querySelector('[data-cao-brochure-viewer]:not([hidden])');
    if (viewer) viewer.hidden = true;
    if (atlasOfferBrochureParent) {
      atlasOfferBrochureParent.removeAttribute('inert');
      atlasOfferBrochureParent.removeAttribute('aria-hidden');
      atlasOfferBrochureParent.scrollTop = atlasOfferBrochureScrollTop;
    }
    if (atlasOfferBrochureVideo && atlasOfferBrochureVideoWasPlaying) {
      atlasOfferBrochureVideo.play().catch(function(){});
    }
    if (
      restoreFocus &&
      atlasOfferBrochureReturnFocus &&
      atlasOfferBrochureReturnFocus.focus &&
      document.contains(atlasOfferBrochureReturnFocus)
    ) {
      atlasOfferBrochureReturnFocus.focus();
    }
    atlasOfferBrochureReturnFocus = null;
    atlasOfferBrochureParent = null;
    atlasOfferBrochureScrollTop = 0;
    atlasOfferBrochureVideo = null;
    atlasOfferBrochureVideoWasPlaying = false;
  }

  function trapAtlasOfferFocus(event, layer){
    var focusable = Array.prototype.slice.call(layer.querySelectorAll('button:not([disabled]),a[href],video[controls]')).filter(function(node){
      return !node.hidden && node.offsetParent !== null;
    });
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function startAtlasOfferCountdown(slot, config){
    if (atlasOfferTimer) window.clearInterval(atlasOfferTimer);
    var output = slot.querySelector('[data-cart-atlas-offer-time]');
    var end = Date.parse(config.endsAt || '');
    if (!output || !Number.isFinite(end)) return;
    function pad(value){ return String(value).padStart(2, '0'); }
    function tick(){
      var difference = Math.max(0, end - Date.now());
      var days = Math.floor(difference / 86400000);
      var hours = Math.floor((difference % 86400000) / 3600000);
      var minutes = Math.floor((difference % 3600000) / 60000);
      var seconds = Math.floor((difference % 60000) / 1000);
      output.textContent = 'Offer ends in ' + pad(days) + 'd : ' + pad(hours) + 'h : ' + pad(minutes) + 'm : ' + pad(seconds) + 's';
      if (difference === 0) {
        slot.hidden = true;
        window.clearInterval(atlasOfferTimer);
      }
    }
    tick();
    atlasOfferTimer = window.setInterval(tick, 1000);
  }

  function selectedAtlasOfferChoice(config){
    var choices = Array.isArray(config && config.addOnChoices)
      ? config.addOnChoices
      : [];
    return choices.find(function(choice){
      return String(choice.variantId) === String(config.addOnVariantId);
    }) || choices[0] || null;
  }

  function atlasOfferChoiceMarkup(config){
    var choices = Array.isArray(config && config.addOnChoices)
      ? config.addOnChoices
      : [];
    if (String(config.addOnScope || 'variant') !== 'family' || choices.length < 2) {
      return '';
    }
    var selected = selectedAtlasOfferChoice(config);
    return '<div class="cao-choice-wrap">' +
      '<p class="cao-choice-label">Choose your colour <span>Price updates instantly</span></p>' +
      '<div class="cao-choices" role="radiogroup" aria-label="Choose add-on colour">' +
        choices.map(function(choice){
          var checked = selected && String(selected.variantId) === String(choice.variantId);
          var choiceImage = choice.image
            ? '<img src="' + escapeHtml(choice.image) + '" alt="">'
            : '<span aria-hidden="true">+</span>';
          return '<button type="button" class="cao-choice" role="radio" aria-checked="' + (checked ? 'true' : 'false') + '" data-cao-variant-choice data-variant-id="' + escapeHtml(choice.variantId) + '" data-product-id="' + escapeHtml(choice.productId) + '" data-handle="' + escapeHtml(choice.handle) + '" data-title="' + escapeHtml(choice.title) + '" data-colour="' + escapeHtml(choice.colorLabel) + '" data-image="' + escapeHtml(choice.image) + '" data-original-cents="' + escapeHtml(String(choice.originalCents)) + '" data-discounted-cents="' + escapeHtml(String(choice.discountedCents)) + '" data-savings-cents="' + escapeHtml(String(choice.savingsCents)) + '" aria-label="' + escapeHtml('Choose ' + choice.colorLabel) + '">' +
            choiceImage +
            '<span><strong>' + escapeHtml(choice.colorLabel) + '</strong><small>' + escapeHtml(fmt(choice.discountedCents)) + '</small></span>' +
          '</button>';
        }).join('') +
      '</div>' +
    '</div>';
  }

  function selectAtlasOfferVariant(button){
    var modal = button && button.closest('.cao-modal');
    if (!modal) return;
    modal.querySelectorAll('[data-cao-variant-choice]').forEach(function(choice){
      choice.setAttribute('aria-checked', choice === button ? 'true' : 'false');
    });
    var originalCents = Number(button.dataset.originalCents || 0);
    var discountedCents = Number(button.dataset.discountedCents || 0);
    var savingsCents = Number(button.dataset.savingsCents || 0);
    var addButton = modal.querySelector('[data-atlas-offer-add]');
    if (addButton) {
      addButton.dataset.addOnVariantId = button.dataset.variantId || '';
      addButton.textContent = 'Yes, add ' + (button.dataset.colour || 'this colour') + ' — ' + fmt(discountedCents);
    }
    var price = modal.querySelector('[data-cao-selected-price]');
    var regular = modal.querySelector('[data-cao-selected-regular]');
    var saving = modal.querySelector('[data-cao-selected-saving]');
    if (price) price.textContent = fmt(discountedCents);
    if (regular) regular.textContent = 'Regular ' + fmt(originalCents);
    if (saving) saving.textContent = 'YOU SAVE ' + fmt(savingsCents);
    modal.querySelectorAll('[data-cao-selected-image]').forEach(function(node){
      node.src = button.dataset.image || '';
      node.alt = button.dataset.title || 'Selected add-on';
    });
    var title = modal.querySelector('[data-cao-selected-title]');
    if (title) title.textContent = button.dataset.title || 'Add-on product';
    var details = modal.querySelector('[data-cao-selected-details]');
    if (details) details.href = '/products/' + encodeURIComponent(button.dataset.handle || '');
  }

  function renderAtlasCartOffer(cart, options){
    var run = ++atlasOfferRenderRun;
    var slot = ensureAtlasOfferSlot();
    var addedVariantId = options && options.offerTriggerVariantId
      ? String(options.offerTriggerVariantId)
      : '';
    if (!addedVariantId) return;
    if (!cart || !cart.items || !cart.items.length) {
      closeAtlasOfferModal(false);
      return;
    }
    findAtlasOfferForCart(cart).then(function(config){
      if (run !== atlasOfferRenderRun) return;
      if (!config) {
        closeAtlasOfferModal(false);
        return;
      }
      var triggerItem = cartTriggerItem(cart, config);
      var justAddedTrigger = (cart.items || []).some(function(item){
        return String(item.variant_id) === addedVariantId &&
          String(item.product_id) === String(config.triggerProductId);
      });
      if (!triggerItem || !justAddedTrigger) return;
      cacheAtlasOfferExperience(config);
      var selectedChoice = selectedAtlasOfferChoice(config);
      if (selectedChoice) {
        config.addOnVariantId = selectedChoice.variantId;
        config.addOnProductId = selectedChoice.productId || config.addOnProductId;
        config.addOnHandle = selectedChoice.handle || config.addOnHandle;
        config.addOnTitle = selectedChoice.title || config.addOnTitle;
        config.addOnImage = selectedChoice.image || config.addOnImage;
      }
      var originalCents = Number((selectedChoice && selectedChoice.originalCents) || config.originalCents || 0);
      var discountedCents = Number((selectedChoice && selectedChoice.discountedCents) || config.discountedCents || 0);
      var savingsCents = Number((selectedChoice && selectedChoice.savingsCents) || config.savingsCents || Math.max(0, originalCents - discountedCents));
      var triggerContext = atlasOfferTriggerContext(config);
      var addOnKind = atlasOfferProductKind(config.addOnTitle) || 'add-on';
      var discountPercent = String(config.discountPercent || '');
      var socialProof = triggerContext.noun === 'purchase'
        ? 'A smart add-on for this purchase: add the ' + addOnKind + ' now so both items ship together, and lock the limited-time ' + discountPercent + '% saving before checkout.'
        : 'A smart ' + triggerContext.noun + ' add-on: add the ' + addOnKind + ' now so both items ship together, and lock the limited-time ' + discountPercent + '% saving before checkout.';
      var giftPrompt = 'Make someone’s day: add this ' + addOnKind + ' to your order now at the limited-time offer price.';
      var features = buildAtlasOfferFeatures(config);
      var summary = String(config.addOnSummary || '').trim();
      var image = config.addOnImage
        ? '<img data-cao-selected-image src="' + escapeHtml(config.addOnImage) + '" alt="' + escapeHtml(config.addOnTitle || 'Add-on product') + '">'
        : '<span aria-hidden="true">+</span>';
      var reel = String(config.reelUrl || '');
      var mediaHero = reel.indexOf('http') === 0
        ? '<div class="cao-video"><video src="' + escapeHtml(reel) + '" muted autoplay loop playsinline controls preload="metadata" aria-label="' + escapeHtml(config.addOnTitle || 'Offer product') + ' product reel"></video></div>'
        : '<div class="cao-product-hero">' + image + '</div>';
      var infographicUrls = Array.isArray(config.infographicUrls)
        ? config.infographicUrls.filter(function(url){return String(url || '').indexOf('http') === 0;}).slice(0, 2)
        : [];
      var brochures = infographicUrls.length
        ? '<div class="cao-brochure-label"><span>PRODUCT INFORMATION</span><span>Open to read full size</span></div>' +
          '<div class="cao-brochures">' + infographicUrls.map(function(url, index){
            return '<button type="button" class="cao-brochure" data-cao-brochure-open="' + index + '" aria-label="Open product information card ' + (index + 1) + ' full size">' +
              '<img src="' + escapeHtml(url) + '" alt="' + escapeHtml((config.addOnTitle || 'Add-on product') + ' information card ' + (index + 1)) + '" loading="eager">' +
              '<span class="cao-brochure-index">INFO ' + (index + 1) + '</span>' +
              '<span class="cao-brochure-zoom" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><circle cx="11" cy="11" r="7"></circle><path d="m20 20-4-4M11 8v6M8 11h6"></path></svg></span>' +
              '<span class="cao-brochure-view">VIEW FULL SIZE</span>' +
            '</button>';
          }).join('') + '</div>'
        : '';
      var brochureViewer = infographicUrls.length
        ? '<div class="cao-lightbox" data-cao-brochure-viewer data-cao-brochure-index="0" hidden>' +
            '<button type="button" class="cao-lightbox-backdrop" data-cao-brochure-close tabindex="-1" aria-label="Close full-size product information"></button>' +
            '<section class="cao-lightbox-dialog" role="dialog" aria-modal="true" aria-labelledby="cao-brochure-title">' +
              '<button type="button" class="cao-lightbox-close" data-cao-brochure-close aria-label="Close and return to offer"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.3" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"></path></svg></button>' +
              '<div class="cao-lightbox-stage">' +
                '<p class="cao-lightbox-kicker">PRODUCT DETAILS · FULL-SIZE VIEW</p>' +
                '<div class="cao-lightbox-image-wrap"><img class="cao-lightbox-image" data-cao-brochure-image src="' + escapeHtml(infographicUrls[0]) + '" alt="' + escapeHtml((config.addOnTitle || 'Add-on product') + ' information card 1') + '"></div>' +
                '<p class="cao-lightbox-count" data-cao-brochure-count>Information card 1 of ' + infographicUrls.length + '</p>' +
                (infographicUrls.length > 1
                  ? '<button type="button" class="cao-lightbox-nav cao-lightbox-prev" data-cao-brochure-nav="-1" aria-label="Previous information card"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><path d="m15 18-6-6 6-6"></path></svg></button>' +
                    '<button type="button" class="cao-lightbox-nav cao-lightbox-next" data-cao-brochure-nav="1" aria-label="Next information card"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><path d="m9 18 6-6-6-6"></path></svg></button>'
                  : '') +
              '</div>' +
              '<aside class="cao-lightbox-rail">' +
                '<h3 id="cao-brochure-title" data-cao-brochure-title>Product information 1</h3>' +
                '<p>Review the features clearly, then return to the same offer without losing your place.</p>' +
                '<div class="cao-lightbox-thumb-list">' + infographicUrls.map(function(url, index){
                  return '<button type="button" class="cao-lightbox-thumb" data-cao-brochure-choice="' + index + '" data-cao-brochure-url="' + escapeHtml(url) + '" data-cao-brochure-alt="' + escapeHtml((config.addOnTitle || 'Add-on product') + ' information card ' + (index + 1)) + '" data-cao-brochure-title="Product information ' + (index + 1) + '" aria-label="View product information card ' + (index + 1) + ' full size" aria-current="' + (index === 0 ? 'true' : 'false') + '">' +
                    '<img src="' + escapeHtml(url) + '" alt="" aria-hidden="true">' +
                    '<span><strong>Information ' + (index + 1) + '</strong><span>Tap to view full size</span></span>' +
                  '</button>';
                }).join('') + '</div>' +
                '<button type="button" class="cao-lightbox-back" data-cao-brochure-close>Back to my offer</button>' +
                '<p class="cao-lightbox-note">Your price, saving and countdown stay exactly as shown.</p>' +
              '</aside>' +
            '</section>' +
          '</div>'
        : '';
      var ruleId = escapeHtml(String(config.ruleId));
      slot.innerHTML =
        '<button type="button" class="cao-backdrop" data-atlas-offer-decline data-offer-rule-id="' + ruleId + '" aria-label="No thanks, close this offer"></button>' +
        '<section class="cao-modal" role="dialog" aria-modal="true" aria-labelledby="cao-title" aria-describedby="cao-summary" tabindex="-1">' +
          '<div class="cao-topline"></div>' +
          '<button type="button" class="cao-close" data-atlas-offer-decline data-offer-rule-id="' + ruleId + '" aria-label="No thanks, close offer">&times;</button>' +
          '<div class="cao-grid">' +
            '<div class="cao-media">' +
              '<div class="cao-media-label"><span>WATCH BEFORE YOU DECIDE</span><span>Product video</span></div>' +
              mediaHero +
              brochures +
              '<p class="cao-media-note">Review the product reel and information cards before you decide.</p>' +
            '</div>' +
            '<div class="cao-content">' +
              '<span class="cao-eyebrow">EXCLUSIVE WITH ' + escapeHtml(triggerContext.eyebrow) + ' · ' + escapeHtml(discountPercent) + '% OFF</span>' +
              '<h2 id="cao-title">A smart add-on at a price that is hard to miss.</h2>' +
              '<p class="cao-subtitle">Your ' + escapeHtml(config.triggerTitle || 'selected product') + ' stays at its regular price. Only this add-on receives the discount.</p>' +
              '<div class="cao-social-proof">' + escapeHtml(socialProof) + '</div>' +
              '<div class="cao-gift-prompt"><span aria-hidden="true">🎁</span><span>' + escapeHtml(giftPrompt) + '</span></div>' +
              atlasOfferChoiceMarkup(config) +
              '<div class="cao-pricing"><div class="cao-price"><b data-cao-selected-price>' + escapeHtml(fmt(discountedCents)) + '</b><s data-cao-selected-regular>Regular ' + escapeHtml(fmt(originalCents)) + '</s></div><span class="cao-save" data-cao-selected-saving>YOU SAVE ' + escapeHtml(fmt(savingsCents)) + '</span></div>' +
              (config.endsAt ? '<div class="cao-countdown" data-cart-atlas-offer-time role="timer" aria-live="off"></div>' : '') +
              '<div class="cao-actions">' +
                '<button type="button" class="cao-add" data-atlas-offer-add data-atlas-offer-source="cart" data-add-on-label="' + escapeHtml(addOnKind) + '" data-trigger-variant-id="' + escapeHtml(String(triggerItem.variant_id || config.triggerVariantId)) + '" data-add-on-variant-id="' + escapeHtml(String(config.addOnVariantId)) + '" data-offer-rule-id="' + ruleId + '" data-offer-expires="' + escapeHtml(String(config.endsAt || '')) + '">Yes, add it to my cart — ' + escapeHtml(fmt(discountedCents)) + '</button>' +
                '<button type="button" class="cao-decline" data-atlas-offer-decline data-offer-rule-id="' + ruleId + '">No thanks</button>' +
              '</div>' +
              '<div class="cao-product">' +
                '<a class="cao-image" data-cao-selected-details href="/products/' + encodeURIComponent(config.addOnHandle || '') + '" aria-label="View ' + escapeHtml(config.addOnTitle || 'add-on product') + '">' + image + '</a>' +
                '<div class="cao-copy"><strong data-cao-selected-title>' + escapeHtml(config.addOnTitle || 'Add-on product') + '</strong><p id="cao-summary">' + escapeHtml(summary || 'A useful everyday upgrade that ships together with ' + triggerContext.possessive + '.') + '</p></div>' +
              '</div>' +
              '<div class="cao-features">' + features.map(function(feature){return '<span class="cao-feature">' + escapeHtml(feature) + '</span>';}).join('') + '</div>' +
              '<p class="cao-proof">Both items ship together. Shopify applies the exact ' + escapeHtml(String(config.discountPercent || '')) + '% add-on discount automatically at checkout.</p>' +
              '<a class="cao-details" href="/products/' + encodeURIComponent(config.addOnHandle || '') + '">View full product details</a>' +
            '</div>' +
          '</div>' +
        '</section>' +
        brochureViewer;
      atlasOfferReturnFocus = document.activeElement;
      slot.hidden = false;
      recordAtlasOfferEvent(config.ruleId, 'presented');
      startAtlasOfferCountdown(slot, config);
      window.setTimeout(function(){
        var dialog = slot.querySelector('.cao-modal');
        if (dialog) dialog.focus();
      }, 0);
    });
  }

  function atlasOfferRuleId(it){
    return it && it.properties && it.properties._atlas_offer_type === 'add_on'
      ? String(it.properties._atlas_offer_rule_id || '')
      : '';
  }

  function cartItemHandle(it){
    if (it && it.handle) return String(it.handle);
    var url = String((it && it.url) || '');
    return url.indexOf('/products/') >= 0
      ? url.split('/products/').pop().split('?')[0]
      : '';
  }

  function trustedCartReelUrl(value){
    var url = String(value || '').trim();
    if (url.indexOf('//') === 0) url = 'https:' + url;
    if (!/^https:\/\/[^"'<> ]+\.mp4(?:\?[^"'<> ]*)?$/i.test(url)) return '';
    try {
      var host = new URL(url).hostname.toLowerCase();
      var allowed =
        host === 'boost-lifestyle.co' ||
        host === 'cdn.shopify.com' ||
        host === 'zpefopnpabbgvldtvpka.supabase.co';
      return allowed ? url : '';
    } catch(_) {
      return '';
    }
  }

  function findCartReelInProductDocument(doc){
    if (!doc) return '';
    var sources = doc.querySelectorAll(
      '[data-bpdp-media-type="video"][data-bpdp-media-src]'
    );
    for (var i = 0; i < sources.length; i += 1) {
      var source = trustedCartReelUrl(sources[i].getAttribute('data-bpdp-media-src'));
      if (source) return source;
    }
    return '';
  }

  function seedInlineCartReel(handle){
    if (!handle || Object.prototype.hasOwnProperty.call(atlasCartReelCache, handle)) {
      return atlasCartReelCache[handle] || '';
    }
    var currentHandle = String(window.location.pathname || '').split('/products/').pop().split('/')[0];
    if (currentHandle !== handle) return '';
    var reel = findCartReelInProductDocument(document);
    if (reel) atlasCartReelCache[handle] = reel;
    return reel;
  }

  function loadCartItemReel(handle){
    if (!handle) return Promise.resolve('');
    if (Object.prototype.hasOwnProperty.call(atlasCartReelCache, handle)) {
      return Promise.resolve(atlasCartReelCache[handle] || '');
    }
    var inline = seedInlineCartReel(handle);
    if (inline) return Promise.resolve(inline);
    if (atlasCartReelRequests[handle]) return atlasCartReelRequests[handle];
    atlasCartReelRequests[handle] = fetch('/products/' + encodeURIComponent(handle), {
      headers:{'Accept':'text/html'}
    })
      .then(function(response){
        if (!response.ok) return '';
        return response.text();
      })
      .then(function(html){
        if (!html) return '';
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return findCartReelInProductDocument(doc);
      })
      .catch(function(){ return ''; })
      .then(function(reel){
        atlasCartReelCache[handle] = reel || '';
        delete atlasCartReelRequests[handle];
        return atlasCartReelCache[handle];
      });
    return atlasCartReelRequests[handle];
  }

  function cartItemImageHtml(it){
    var imageUrl = it && it.featured_image && it.featured_image.url
      ? String(it.featured_image.url)
      : '';
    var imageAlt = escapeHtml((it && it.product_title) || 'Cart product image');
    var image = imageUrl
      ? '<img src="' + escapeHtml(imageUrl) + '" alt="' + imageAlt + '">'
      : '';
    return {
      imageUrl: imageUrl,
      imageAlt: imageAlt,
      image: image
    };
  }

  function cartItemMedia(it, index){
    var media = cartItemImageHtml(it);
    var ruleId = atlasOfferRuleId(it);
    var offer = readAtlasOfferExperience(ruleId);
    var handle = cartItemHandle(it);
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var reelUrl = trustedCartReelUrl(offer && offer.reelUrl);
    if (!reelUrl) {
      reelUrl = trustedCartReelUrl(atlasCartReelCache[handle]) || seedInlineCartReel(handle);
    }
    if (!atlasCartReelsEnabled || !reelUrl || reduceMotion) {
      return '<div class="cart-item-image atlas-cart-media" data-cart-reel-slot="' + index + '">' + media.image + '</div>';
    }
    return '<div class="cart-item-image atlas-cart-media is-atlas-cart-reel" data-cart-reel-slot="' + index + '">' +
      '<video src="' + escapeHtml(reelUrl) + '" muted loop playsinline preload="metadata" data-cart-reel-video' +
        (media.imageUrl ? ' poster="' + escapeHtml(media.imageUrl) + '"' : '') +
        ' aria-label="' + media.imageAlt + ' product reel"></video>' +
    '</div>';
  }

  function renderCartItemReel(slot, it, reelUrl){
    var trusted = trustedCartReelUrl(reelUrl);
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!atlasCartReelsEnabled || reduceMotion || !slot || !trusted) return;
    var media = cartItemImageHtml(it);
    slot.classList.add('is-atlas-cart-reel');
    slot.innerHTML =
      '<video src="' + escapeHtml(trusted) + '" muted loop playsinline preload="metadata" data-cart-reel-video' +
        (media.imageUrl ? ' poster="' + escapeHtml(media.imageUrl) + '"' : '') +
        ' aria-label="' + media.imageAlt + ' product reel"></video>';
  }

  function pauseAtlasCartReels(){
    drawer.querySelectorAll('[data-cart-reel-video]').forEach(function(video){
      video.pause();
      video.dataset.atlasCartReelVisible = 'false';
    });
  }

  function balanceAtlasCartReels(){
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var playable = [];
    drawer.querySelectorAll('[data-cart-reel-video]').forEach(function(video){
      if (atlasCartReelsEnabled && !reduceMotion && video.dataset.atlasCartReelVisible === 'true' && playable.length < 2) {
        playable.push(video);
      }
    });
    drawer.querySelectorAll('[data-cart-reel-video]').forEach(function(video){
      if (playable.indexOf(video) >= 0) {
        var play = video.play();
        if (play && typeof play.catch === 'function') play.catch(function(){});
      } else {
        video.pause();
      }
    });
  }

  function bindAtlasCartReel(video){
    if (!video || video.dataset.atlasCartReelBound === 'true') return;
    video.dataset.atlasCartReelBound = 'true';
    video.addEventListener('timeupdate', function(){
      if (video.currentTime >= 10) {
        video.currentTime = 0;
        if (video.dataset.atlasCartReelVisible === 'true') {
          var play = video.play();
          if (play && typeof play.catch === 'function') play.catch(function(){});
        }
      }
    });
    video.addEventListener('ended', function(){
      video.currentTime = 0;
      balanceAtlasCartReels();
    });
  }

  function observeAtlasCartReels(){
    if (atlasCartReelObserver) atlasCartReelObserver.disconnect();
    var videos = drawer.querySelectorAll('[data-cart-reel-video]');
    if (!atlasCartReelsEnabled) {
      pauseAtlasCartReels();
      return;
    }
    videos.forEach(bindAtlasCartReel);
    if (!videos.length) return;
    if (!('IntersectionObserver' in window)) {
      videos.forEach(function(video, index){
        video.dataset.atlasCartReelVisible = index < 2 ? 'true' : 'false';
      });
      balanceAtlasCartReels();
      return;
    }
    atlasCartReelObserver = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        entry.target.dataset.atlasCartReelVisible =
          entry.isIntersecting && entry.intersectionRatio >= 0.5 ? 'true' : 'false';
      });
      balanceAtlasCartReels();
    }, {root:drawer, threshold:[0, 0.5, 1]});
    videos.forEach(function(video){
      video.dataset.atlasCartReelVisible = 'false';
      atlasCartReelObserver.observe(video);
    });
  }

  function hydrateCartItemReels(cart){
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!atlasCartReelsEnabled || reduceMotion || !cart || !Array.isArray(cart.items)) {
      pauseAtlasCartReels();
      return;
    }
    observeAtlasCartReels();
    cart.items.forEach(function(item, index){
      var slot = drawer.querySelector('[data-cart-reel-slot="' + index + '"]');
      if (!slot || slot.querySelector('[data-cart-reel-video]')) return;
      loadCartItemReel(cartItemHandle(item)).then(function(reelUrl){
        var currentSlot = drawer.querySelector('[data-cart-reel-slot="' + index + '"]');
        if (!currentSlot || currentSlot.querySelector('[data-cart-reel-video]') || !reelUrl) return;
        renderCartItemReel(currentSlot, item, reelUrl);
        observeAtlasCartReels();
      });
    });
  }

  function linePriceHtml(it){
    var finalLinePrice = Number(it.final_line_price != null ? it.final_line_price : it.line_price || 0);
    var originalLinePrice = Number(it.original_line_price != null ? it.original_line_price : it.line_price || finalLinePrice);
    var allocations = Array.isArray(it.line_level_discount_allocations) ? it.line_level_discount_allocations : [];
    var discountTitle = allocations.map(function(allocation){
      return allocation && allocation.discount_application ? allocation.discount_application.title : '';
    }).filter(Boolean).join(', ');
    var ruleId = atlasOfferRuleId(it);
    if (originalLinePrice > finalLinePrice) {
      var percentage = Math.max(1, Math.round((originalLinePrice - finalLinePrice) / originalLinePrice * 100));
      return '<span class="atlas-offer-line-price">' +
        '<s>' + fmt(originalLinePrice) + '</s>' +
        '<strong>' + fmt(finalLinePrice) + '</strong>' +
        '<span class="atlas-offer-applied">' +
          escapeHtml(ruleId ? percentage + '% ADD-ON SAVING' : (discountTitle ? 'OFFER APPLIED' : 'PRICE SAVING')) +
        '</span>' +
      '</span>';
    }
    return '<strong>' + fmt(finalLinePrice) + '</strong>';
  }

  function setBundleCheckoutBlocked(blocked, productTitle){
    var warning = drawer.querySelector('[data-atlas-bundle-cart-warning]');
    if (blocked && !warning) {
      warning = document.createElement('div');
      warning.setAttribute('data-atlas-bundle-cart-warning', '');
      warning.setAttribute('role', 'alert');
      warning.style.cssText = 'margin:12px 16px;padding:11px 12px;border:1px solid #f2b8b5;border-radius:10px;background:#fff3f2;color:#8c1d18;font-size:12px;font-weight:800;line-height:1.45';
      var items = drawer.querySelector('[data-cart-items]');
      if (items && items.parentNode) items.parentNode.insertBefore(warning, items.nextSibling);
    }
    if (warning) {
      warning.hidden = !blocked;
      if (blocked) warning.textContent = (productTitle || 'This bundle') + ' is no longer available at its bundle price. Remove it before checkout; Boost will not silently charge the full price.';
    }

    drawer.querySelectorAll('[data-cart-checkout], a[href*="/checkout"], button[name="checkout"]').forEach(function(control){
      if (!control.dataset.atlasOriginalText) control.dataset.atlasOriginalText = control.textContent || 'Checkout';
      if (blocked) {
        if (control.getAttribute('href') && !control.dataset.atlasOriginalHref) control.dataset.atlasOriginalHref = control.getAttribute('href');
        control.removeAttribute('href');
        control.setAttribute('aria-disabled', 'true');
        control.disabled = true;
        control.textContent = 'Bundle offer unavailable';
      } else {
        if (control.dataset.atlasOriginalHref) control.setAttribute('href', control.dataset.atlasOriginalHref);
        control.removeAttribute('aria-disabled');
        control.disabled = false;
        control.textContent = control.dataset.atlasOriginalText;
      }
    });
  }

  function validateBundleOffers(cart){
    var run = ++bundleValidationRun;
    var bundleItems = (cart.items || []).filter(function(item){
      return String(item.product_type || '').toLowerCase() === 'bundle' ||
        (item.properties && item.properties._atlas_offer_type === 'bundle');
    });
    if (!bundleItems.length) {
      setBundleCheckoutBlocked(false);
      return;
    }

    Promise.all(bundleItems.map(function(item){
      var handle = item.handle || String(item.url || '').split('/products/').pop().split('?')[0];
      if (!handle) return Promise.resolve({valid:false, title:item.product_title});
      return fetch('/products/' + encodeURIComponent(handle), {headers:{'Accept':'text/html'}})
        .then(function(response){
          if (!response.ok) throw new Error('Could not verify bundle offer');
          return response.text();
        })
        .then(function(html){
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var productRoot = doc.querySelector('[data-bpdp][data-atlas-bundle="true"]');
          if (!productRoot || productRoot.dataset.atlasBundleOfferActive !== 'true') return {valid:false, title:item.product_title};
          var startsAt = Date.parse(productRoot.dataset.atlasBundleOfferStarts || '');
          var endsAt = Date.parse(productRoot.dataset.atlasBundleOfferEnds || '');
          var now = Date.now();
          return {
            valid: (!Number.isFinite(startsAt) || startsAt <= now) && (!Number.isFinite(endsAt) || endsAt > now),
            title:item.product_title
          };
        })
        .catch(function(){ return {valid:false, title:item.product_title}; });
    })).then(function(results){
      if (run !== bundleValidationRun) return;
      var blocked = results.find(function(result){ return !result.valid; });
      setBundleCheckoutBlocked(Boolean(blocked), blocked && blocked.title);
    });
  }

  function paymentDetails(it, idx){
    var blob = ((it.product_title || '') + ' ' + (it.variant_title || '')).toLowerCase();
    var isChair = blob.indexOf('chair') !== -1 || blob.indexOf('ergonomic') !== -1;
    if (!isChair) return '';
    var isCod = blob.indexOf('cod') !== -1;
    var isPrepaid = blob.indexOf('prepaid') !== -1;
    if (!isCod && !isPrepaid) return '';
    var variantOptions = encodeURIComponent(JSON.stringify(it.variant_options || []));
    var handle = it.handle || (it.url || '').split('/products/').pop().split('?')[0];
    var note = isCod
      ? 'COD selected. Checkout will show Cash on Delivery for this COD variant.'
      : 'Prepaid selected. Checkout will open the prepaid payment path for this variant.';
    return '<div class="cart-item-payment-card" data-cart-payment-card>' +
      '<div><strong>Payment selected</strong><span>' + escapeHtml(note) + '</span></div>' +
      '<div class="cart-payment-switches" aria-label="Change payment method">' +
        '<button type="button" data-cart-payment-switch data-payment-target="prepaid" data-line="' + (idx+1) + '" data-qty="' + it.quantity + '" data-handle="' + escapeHtml(handle) + '" data-current-options="' + variantOptions + '"' + (isPrepaid ? ' disabled aria-pressed="true"' : '') + '>Prepaid</button>' +
        '<button type="button" data-cart-payment-switch data-payment-target="cod" data-line="' + (idx+1) + '" data-qty="' + it.quantity + '" data-handle="' + escapeHtml(handle) + '" data-current-options="' + variantOptions + '"' + (isCod ? ' disabled aria-pressed="true"' : '') + '>COD + Rs 2,000</button>' +
      '</div>' +
    '</div>';
  }

  function switchPaymentVariant(btn){
    var handle = btn.dataset.handle;
    var target = (btn.dataset.paymentTarget || '').toLowerCase();
    var line = parseInt(btn.dataset.line || '0', 10);
    var qty = parseInt(btn.dataset.qty || '1', 10);
    if (!handle || !target || !line) return;
    btn.disabled = true;
    btn.textContent = 'Switching...';
    var currentOptions = [];
    try { currentOptions = JSON.parse(decodeURIComponent(btn.dataset.currentOptions || '[]')); } catch(_){}
    fetch('/products/' + handle + '.js', { headers:{ 'Accept':'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(product){
        var variants = product.variants || [];
        var alt = variants.find(function(v){
          var opts = [v.option1, v.option2, v.option3].filter(Boolean);
          var hasTarget = opts.some(function(opt){ return String(opt).toLowerCase().indexOf(target) !== -1; });
          if (!hasTarget || !v.available) return false;
          for (var i=0; i<currentOptions.length; i++){
            var current = String(currentOptions[i] || '');
            var currentLower = current.toLowerCase();
            if (currentLower.indexOf('cod') !== -1 || currentLower.indexOf('prepaid') !== -1) continue;
            if (opts[i] && opts[i] !== current) return false;
          }
          return true;
        });
        if (!alt) throw new Error('No matching payment variant');
        return fetch('/cart.js', { headers:{ 'Accept':'application/json' } })
          .then(function(r){ return r.json(); })
          .then(function(cartNow){
            var oldItem = (cartNow.items || [])[line - 1];
            if (!oldItem) throw new Error('Line not found');
            var fd = new FormData();
            fd.append('id', alt.id);
            fd.append('quantity', qty);
            // Q15 3 Aug 2026: ADD the replacement FIRST, then remove the old line by its
            // unique key — if the add fails the customer keeps their original item.
            return fetch('/cart/add.js', { method:'POST', body:fd, headers:{'Accept':'application/json'} })
              .then(function(ar){
                if (!ar.ok) throw new Error('Add failed');
                return fetch('/cart/change.js', { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({ id: oldItem.key, quantity:0 }) });
              });
          });
      })
      .then(function(){
        return refresh().then(openDrawer);
      })
      .catch(function(){
        if (window.Boost && window.Boost.toast) window.Boost.toast('<span class="boost-toast-icon">!</span> Could not switch payment. Open the product page and choose Prepaid or COD.', 'error');
        refresh();
      });
  }

  // BAADMAY START: sync drawer widget with the same cart used for its subtotal.
  function updateBaadmayCartWidget(cart){
    var totalCents = Number(cart.total_price);
    var visible = Number(cart.item_count) > 0 &&
    Number.isSafeInteger(totalCents) && totalCents > 0 && totalCents <= 9500000 &&
    Number.isSafeInteger(totalCents * 115);
    var installment = visible ? Math.floor(totalCents * 115 / 30000) : 0;
    drawer.querySelectorAll('.baadmay-gateway-wrapper.baadmay-cart').forEach(function(widget){
      widget.hidden = !visible;
      if (visible) {
        widget.style.removeProperty('display');
      } else {
        widget.style.setProperty('display', 'none', 'important');
      }
      widget.querySelectorAll('baadmaypricerre').forEach(function(price){
        price.setAttribute('total-cart-price', String(visible ? totalCents / 100 : 0));
        price.textContent = installment.toLocaleString('en-PK', {maximumFractionDigits: 0});
      });
    });
  }
  // BAADMAY END

  function render(cart, options){
    var itemsEl = drawer.querySelector('[data-cart-items]');
    var totalEl = drawer.querySelector('[data-cart-total]');
    var countEl = drawer.querySelector('[data-cart-header-count]');
    if (countEl) countEl.textContent = cart.item_count;

    if (cart.item_count === 0) {
      itemsEl.innerHTML = '<div class="cart-empty"><p>' + escapeHtml(copy.emptyText) + '</p><a href="/collections/all" class="cart-empty-cta">' + escapeHtml(copy.emptyCta) + ' →</a></div>';
    } else {
      itemsEl.innerHTML = cart.items.map(function(it, idx){
        return '<div class="cart-item" data-cart-item-index="' + idx + '">' +
          cartItemMedia(it, idx) +
          '<div class="cart-item-content">' +
            '<div class="cart-item-title"><a href="' + it.url + '">' + escapeHtml(it.product_title) + '</a></div>' +
            (it.variant_title && it.variant_title !== 'Default Title' ? '<div class="cart-item-variant">' + escapeHtml(it.variant_title) + '</div>' : '') +
            paymentDetails(it, idx) +
            '<div class="cart-item-qty">' +
              '<button data-cart-line-qty="' + (it.quantity-1) + '" data-line="' + (idx+1) + '" aria-label="Decrease quantity">−</button>' +
              '<input value="' + it.quantity + '" readonly>' +
              '<button data-cart-line-qty="' + (it.quantity+1) + '" data-line="' + (idx+1) + '" aria-label="Increase quantity">+</button>' +
            '</div>' +
            '<button class="cart-item-remove" data-cart-remove="' + (idx+1) + '">' + escapeHtml(copy.removeLabel) + '</button>' +
          '</div>' +
          '<div class="cart-item-price">' + linePriceHtml(it) + '</div>' +
        '</div>';
      }).join('');
    }
    hydrateCartItemReels(cart);

    if (totalEl) totalEl.textContent = fmt(cart.total_price);

    // BAADMAY START: run after every add, remove, quantity change and drawer refresh.
    updateBaadmayCartWidget(cart);
    // BAADMAY END

    // Free shipping is unconditional (no minimum) — always confirm it, no threshold bar.
    var prog = drawer.querySelector('[data-cart-progress]');
    if (prog) {
      prog.innerHTML = '<div class="cart-shipping-progress-text"><strong>' + escapeHtml(copy.freeQualified) + '</strong></div>';
    }

    // Generic recommendations must never imply a discount. Exact Atlas offers
    // render on the product page from verified metafields and Shopify rules.
    var bundle = drawer.querySelector('[data-cart-bundle]');
    if (bundle) bundle.style.display = 'none';

    // Show only the exact, current Atlas rule attached to a cart trigger.
    renderAtlasCartOffer(cart, options || {});

    // Order Journey — category-aware wow moment between cart items and checkout
    renderMotivation(cart);
    validateBundleOffers(cart);
  }

  function renderMotivation(cart){
    var slot = drawer.querySelector('[data-cart-motivation]');
    if (!slot) return;
    if (!cart || !cart.items || cart.items.length === 0){
      slot.innerHTML = '';
      slot.style.display = 'none';
      return;
    }
    var blob = cart.items.map(function(it){return (it.product_title||'').toLowerCase();}).join(' ');
    var cat = 'general';
    if (blob.indexOf('chair') !== -1 || blob.indexOf('ergonomic') !== -1) cat = 'chair';
    else if (blob.indexOf('earbud') !== -1 || blob.indexOf('tws') !== -1 || blob.indexOf('hawk') !== -1 || blob.indexOf('falcon') !== -1) cat = 'earbud';
    else if (blob.indexOf('headset') !== -1 || blob.indexOf('headphone') !== -1) cat = 'audio';
    else if (blob.indexOf('watch') !== -1) cat = 'watch';
    else if (blob.indexOf('power bank') !== -1 || blob.indexOf('powerbank') !== -1 || blob.indexOf('voltron') !== -1) cat = 'power';
    var copyMap = {
      chair:   {kicker: 'Comfort journey',  head: 'Your chair is almost reserved.',              sub: 'Complete checkout now so the team can confirm your WhatsApp number, delivery details and assembly help.'},
      audio:   {kicker: 'Sound journey',    head: 'Your audio upgrade is almost reserved.',      sub: 'Complete checkout now so Zaara can help with pairing, delivery and after-order questions.'},
      earbud:  {kicker: 'Pocket sound',     head: 'Your portable sound is almost reserved.',     sub: 'Complete checkout now so Zaara can help with pairing, fit and delivery updates.'},
      watch:   {kicker: 'Daily wear',       head: 'Your watch is almost reserved.',              sub: 'Complete checkout now so Zaara can help with pairing, delivery and daily-use questions.'},
      power:   {kicker: 'Everyday power',   head: 'Your backup power is almost reserved.',       sub: 'Complete checkout now so Zaara can help with delivery and product questions.'},
      general: {kicker: 'Boost setup',      head: 'Your Boost order is almost reserved.',        sub: 'Complete checkout now so Zaara can stay with you before and after delivery.'}
    };
    var c = copyMap[cat];
    var acceptedOfferItem = cart.items.find(function(item){return Boolean(atlasOfferRuleId(item));});
    var acceptedOffer = acceptedOfferItem ? readAtlasOfferExperience(atlasOfferRuleId(acceptedOfferItem)) : null;
    var acceptedSavingCents = acceptedOfferItem
      ? Math.max(0, Number(acceptedOfferItem.original_line_price || 0) - Number(acceptedOfferItem.final_line_price || 0))
      : 0;
    var acceptedOfferDiscountApplied = Boolean(
      acceptedOfferItem &&
      acceptedSavingCents > 0 &&
      (acceptedOfferItem.line_level_discount_allocations || []).some(function(allocation){
        var title = allocation && allocation.discount_application
          ? String(allocation.discount_application.title || '')
          : '';
        return /^atlas add-on\b/i.test(title);
      })
    );
    if (acceptedOfferDiscountApplied) {
      var acceptedTriggerContext = acceptedOffer ? atlasOfferTriggerContext(acceptedOffer) : null;
      var acceptedOfferSubject = acceptedTriggerContext && acceptedTriggerContext.noun !== 'purchase'
        ? acceptedTriggerContext.possessive
        : 'your main product';
      acceptedOfferSubject = acceptedOfferSubject.charAt(0).toUpperCase() + acceptedOfferSubject.slice(1);
      c = {
        kicker: 'Saving secured',
        head: 'Smart choice — your limited-time add-on saving is secured.',
        sub: acceptedOfferSubject + ' stays at its regular price, and only the add-on receives the discount. Complete checkout to keep both together.'
      };
    }
    var zaaraSrc = slot.dataset.zaaraAvatar || '/cdn/shop/files/zaara-avatar.png';
    var steps = [
      {n: 1, t: acceptedOfferDiscountApplied ? 'Secured' : 'Selected',  s: acceptedOfferDiscountApplied ? 'Offer saving' : 'Right product',     active: true },
      {n: 2, t: 'Confirmed', s: 'WhatsApp ping',     active: false},
      {n: 3, t: 'Checked',   s: 'Packed clean',      active: false},
      {n: 4, t: 'Arriving',  s: 'Relax soon',        active: false}
    ];
    slot.style.display = '';
    slot.innerHTML =
      '<aside class="cart-motivation cart-journey" data-cart-journey>' +
        '<div class="cart-journey-head">' +
          '<div class="cart-journey-avatar">' +
            '<img src="' + zaaraSrc + '" alt="Zaara" loading="lazy" onerror="this.style.display=\'none\';this.nextElementSibling.style.display=\'flex\';">' +
            '<span style="display:none">Z</span>' +
          '</div>' +
          '<div class="cart-journey-head-copy">' +
            '<div class="cart-motivation-kicker">' + escapeHtml(c.kicker) + '</div>' +
            '<strong>' + escapeHtml(c.head) + '</strong>' +
            '<p>' + escapeHtml(c.sub) + '</p>' +
          '</div>' +
        '</div>' +
        (acceptedOfferDiscountApplied
          ? '<div class="cart-offer-secured-banner"><span aria-hidden="true">✓</span><span><b>' +
              escapeHtml(String((acceptedOffer && acceptedOffer.discountPercent) || '30')) +
              '% add-on saving selected</b>' +
              (acceptedSavingCents > 0 ? ' · You save ' + escapeHtml(fmt(acceptedSavingCents)) : '') +
            '</span></div>'
          : '') +
        '<div class="cart-journey-route">' +
          '<div class="cart-journey-road"><span aria-hidden="true">BOOST</span></div>' +
          '<div class="cart-journey-steps">' +
            steps.map(function(st){
              return '<div class="cart-journey-step' + (st.active ? ' is-active' : '') + '">' +
                       '<span>' + st.n + '</span>' +
                       '<strong>' + escapeHtml(st.t) + '</strong>' +
                       '<em>' + escapeHtml(st.s) + '</em>' +
                     '</div>';
            }).join('') +
          '</div>' +
        '</div>' +
        '<div class="cart-motivation-actions" style="margin-top:14px;display:flex;flex-wrap:wrap;gap:8px;justify-content:center">' +
          '<span style="display:inline-flex;align-items:center;gap:6px;padding:6px 12px;border-radius:999px;background:#ecfdf5;color:#0d6b4f;font-size:11px;font-weight:900">✓ 14-day return window</span>' +
          '<span style="display:inline-flex;align-items:center;gap:6px;padding:6px 12px;border-radius:999px;background:#ecfdf5;color:#0d6b4f;font-size:11px;font-weight:900">✓ 1-year warranty</span>' +
          '<span style="display:inline-flex;align-items:center;gap:6px;padding:6px 12px;border-radius:999px;background:#ecfdf5;color:#0d6b4f;font-size:11px;font-weight:900">✓ Delivery estimate at checkout</span>' +
          '<span style="display:inline-flex;align-items:center;gap:6px;padding:6px 12px;border-radius:999px;background:#fff4b8;color:#3a2a00;font-size:11px;font-weight:900">Zaara 24/7 WhatsApp help</span>' +
        '</div>' +
      '</aside>';
  }
  function escapeHtml(s){
    return String(s).replace(/[&<>"']/g, function(c){
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];
    });
  }

  // Keep drawer in sync after any /cart/add posted from outside
  document.addEventListener('cart:updated', refresh);
  refresh();
}());

/* Generic cart recommendations stay hidden. Exact Atlas offers are rendered
   only from verified product metafields and Shopify automatic discounts. */
